export const SUPPORTED_DATA_TYPES = new Set([
    'Link',
    'TextLink',
    'MediaRichText',
    'Text',
    'RichText',
    'RichTextImage',
    'QuickActionBarItem',
    'FlashComponent',
    'SelectOption',
    'SiteButton',
    'StyledText',
    'VKShareButton',
    'mobui.MobuiText',
    'CollapsibleTextData',
    'TextFxData',
    'dsgnsys.DashboardHeading',
    'dsgnsys.DashboardText',
    'dsgnsys.WbuLeftTextButton',
    'dsgnsys.WutBadge'
])
